
export const environment = {
  production: false,
  title: 'Production Environment',
  apiURL: 'https://herbslyf.com/api',
  b2bApiUrl: 'https://herbslyf.com/api/api/v1/B2B/admin',
  b2bApiUrl2: 'https://herbslyf.com/api/api/v1/B2B',
  salesApiURL: 'https://herbslyf.com/api/api/v1/Sales/Admin',
  imageUrl: 'https://herbslyf.com/api/images',
  blogImageUrl: 'https://herbslyf.com/api/blog',
  bannerImageUrl: 'https://herbslyf.com/api/banner',
  thumbNailUrl: 'https://herbslyf.com/api/thumbnail',
  domainUrl: 'https://herbslyf.com/',
};